















import { Component, Prop, Vue, Emit } from "vue-property-decorator";

const ModalProps = Vue.extend({
  props: {
    title: String,
    text: String,
  }
});

@Component({
  components: {
  }
})
export default class Modal extends ModalProps {
  mounted() {
    console.log("title: " + this.title)
  }

  @Emit()
  ok(){
this.close()
  }

  @Emit()
  cancel(){
  this.close()
  }

  @Emit()
  close(){
  
  }
}
